import BasicTooltip from "./BasicTooltip";

export default BasicTooltip;
